"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsSeederV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_lilVRGDA",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "generateSeedForBlock",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lilVRGDA",
        outputs: [
            {
                internalType: "contract ILilVRGDA",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsSeederV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_lilVRGDA, overrides) {
        return super.deploy(_lilVRGDA, overrides || {});
    }
    getDeployTransaction(_lilVRGDA, overrides) {
        return super.getDeployTransaction(_lilVRGDA, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsSeederV2__factory = NounsSeederV2__factory;
NounsSeederV2__factory.bytecode = _bytecode;
NounsSeederV2__factory.abi = _abi;
